<ng-container *transloco="let t">
    <div class="main-footer">
        <div class="container">
            <cool-logo></cool-logo>
    
            <span class="copyright">{{ t('copyright') }}</span>
        </div>
    </div>
</ng-container>